import NavigationBar from '../Components/NavigationBar/NavigationBar';

function Ams({ user }) {
  return (
    <div>
        <NavigationBar user={user} />
    </div>
  )
}

export default Ams;